import React from "react";
import {cardBodyClass,cardClass} from "./surfaceStyles";import {cn} from "./formStyles";
export default function SectionCard({children,className="",bodyClassName=""}){return <section className={cn(cardClass,className)}><div className={cn(cardBodyClass,bodyClassName)}>{children}</div></section>}
